<template>
  <div>
    <div v-if="finished" class="container tx-center">
      <div
        class="
          ht-100p
          d-flex
          flex-column
          align-items-center
          justify-content-center
        "
      >
        <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
          <img src="assets/svg/zoom.svg" class="img-fluid" alt="" />
        </div>
        <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5">
          {{ task.task }}
        </h1>
        <h5 class="tx-14 tx-normal text-uppercase mg-b-30">[Онлайн уулзалт]</h5>
        <p class="tx-color-03 mg-b-10">Хурал дууссан байна</p>
        <div class="mg-b-40">
          <router-link
            :to="{
              name: 'lmsCourseView',
              params: { id: $route.params.id, bid: 0, iid: 0, bot: 0 }
            }"
            class="btn btn-white pd-x-30"
            >Сургалтын эхлэл</router-link
          >
        </div>
      </div>
    </div>
    <div
      v-else-if="rdy"
      id="jaas-container"
      class="wd-100p"
      :style="`height: ${getScrollHeight()}; z-index: 99999999`"
    ></div>

    <div v-else class="container tx-center">
      <div
        class="
          ht-100p
          d-flex
          flex-column
          align-items-center
          justify-content-center
        "
      >
        <div class="wd-70p wd-sm-250 wd-lg-300 mg-b-15">
          <img src="assets/svg/zoom.svg" class="img-fluid" alt="" />
        </div>
        <h1 class="tx-color-01 tx-24 tx-sm-32 tx-lg-36 mg-xl-b-5">
          {{ task.task }}
        </h1>
        <h5 class="tx-14 tx-normal text-uppercase mg-b-30">[Онлайн уулзалт]</h5>
        <p class="tx-color-03 mg-b-10">Үргэлжлэх хугацаа</p>
        <p class="tx-color-03">
          {{ task.dueStartDate | moment("YYYY.MM.DD HH:mm, dddd") }} -
          {{ task.dueDate | moment("YYYY.MM.DD HH:mm, dddd") }}
        </p>
        <vue-countdown
          @end="timerEnded"
          :time="getSeconds(task.dueStartDate)"
          v-slot="{ days, hours, minutes, seconds }"
          class="mg-b-30"
        >
          {{ days }}өдөр : {{ hours }}цаг : {{ minutes }}минут :
          {{ seconds }}секунд
        </vue-countdown>
        <div class="mg-b-40">
          <router-link
            :to="{
              name: 'lmsCourseView',
              params: { id: $route.params.id, bid: 0, iid: 0, bot: 0 }
            }"
            class="btn btn-white pd-x-30"
            >Сургалтын эхлэл</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCountdown from "@chenfengyuan/vue-countdown";
var jsonwebtoken = require("jsonwebtoken");
import { hasOneOf } from "@/libs/tools";

//const meetingUrl="meet.gosmart.mn";
const meetingUrl = "statemeet.gosmart.mn";

export default {
  components: {
    VueCountdown
  },
  props: {
    task: {
      type: Object,
      default: () => {}
    },
    course: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      notifications: [],
      rdy: false,
      finished: false,
      privateKey: `-----BEGIN PRIVATE KEY-----
MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQCX4VhVAZDPhG/7
n76HjQucbXrtmpion8ON/azJRuezdkjjUjJZJnpT1FTXch0y5JN/tQluZfkkOMjJ
jhUibtsCsW7r55Y+RoPF3Tn24EFEuNKxd1GbKMmc7K8HjdAmBW974tS6cVoM2HvE
650WEK2rTCDsT8m3yG69liSqPj5bwCIKhZ152G9tB/9Gz9fqhGlhcepDX+SSe26b
F5dT0htlkjC0WQX5DAtDu67gtaqweDFtm487sY1Y8DEDwMmRAxTdRkNg5/QYNW4j
UMcLcWZ2iwBK9OPz31BQ0Hy0Q22+ykajrZgTccFXTiQa2MBO9m2MaYCxwEO39ff1
TUNrI8U/AgMBAAECggEAC3P0w0RA9UUZZLIhHfum2n7u/CfiRyT1DCoK84qjQkcz
K+Ew5sQeCWBDnZN/XC0cak7ujSKnbPHTQk+yjEwru8JBiQyHqd6LZUpPaqxyf4oo
aTWEM90ZhvnaIQmynoteYssyG3Ucw0c33hueVuGfFwHAodFKds9oemduEGBtN2Hh
5HIho38aUiBNs1UfZ84WxiHrskHc+4tSdPAplivV+ES0y6U146MmIPep0Wq/Y4VM
y/tbDxg2bEsLDW1wOjRGTacq352nTigDcpxbUXDugnfbRvfJGlEpDXv3NCevCdgC
0RHo9olKzsb5cBjKFI80THY1OAUlpwjVH2EuLwUTsQKBgQDRXowKz7YKhFPR4PHd
Z9vI64g11vbrgP1JlCSOyQl8aMCucuXtQZuYjLQDjZH0elkJrmYl+N+PBqZjaZF6
dyl7enjf68YtwJcGANoCe2XiDvGaMNWSbpTe1ehoCD/z2wGGXJWUB+lDR/fFebjy
DUtGko6m0M+eF56fNo09NcSJdQKBgQC5tPytNLcSe18hFpGwfZvADDP/Ae4j/XtY
6wxjfLlH2mM4riCnVRFADDOOQqM0LWIrTntkXk//idi0MgoiQoocPR5guSvGxDqO
H8fJwNQXwevGgzkckyjosT6n/MbpLrzNe5UPupthxeUfK2u8kwhz+CvH1xQzCIoa
eC58gueJYwKBgFSHImz+/RTz5c9XTO7BjpdomB58gkYEVr5NBBFtktnahOgpVTDb
ixEkxUyl7GZSuv3Qnkb4WnGpEqYSKfzSfTnv8TseOm2gUpjG4T2dSj3hIKPK0X8E
DDCHFgRiSEeQhOYVHQKdywwx0xO0F/oJafm9E8C/jwLZsF3BLXan7Yg9AoGAQkF2
XP2Py4JEwHNi60sFRJGWA4dWxXRsi57gvqYDHMWn3NMTR2AsVWOFCV5xB+6hNb48
e+TCOfOeYzvvLaX7zHNp4Sxvl+zuz0I7b5nikc9YJW0v9Sfz0oFaT2j6Nru8FLvg
xMnZIhsO0f4V5CO5Qlbql9P+mu6TBzqVq0qw/O0CgYATB446FzfAMQAhf4Lk5JEs
6v7/AKvxLT3bBkv8U1yjpdaF3hr3W5dnJhYIfl2zYdfJ3ZzebZRV/11R8dkGsE02
f2aW4vXDV5GWParBn4fyr47hOWpjI8ZWU/v0c85DJYzP/xcnedsh/+hZVG1Gdqal
8kIaW8lpXnLJhNXv0LpyBA==
-----END PRIVATE KEY-----`,
      toolbarButtons: [
        "microphone",
        "camera",
        "closedcaptions",
        "desktop",
        "embedmeeting",
        "fullscreen",
        "fodeviceselection",
        "hangup",
        "profile",
        "recording",
        "livestreaming",
        "etherpad",
        "sharedvideo",
        "shareaudio",
        "settings",
        "raisehand",
        "videoquality",
        "filmstrip",
        "stats",
        "shortcuts",
        "tileview",
        "select-background",
        "mute-everyone",
        "mute-video-everyone",
        "security"
      ]
    };
  },
  mounted() {
    let _range =
      new Date(this.course.date.now).getTime() -
      new Date(this.task.dueDate).getTime();
    if (_range > 0) {
      this.finished = true;
      //console.log('_range', _range);
    }
  },
  methods: {
    getScrollHeight() {
      let mh = 105;
      if (this.$store.state.app.isMobile) {
        mh = 55;
      }
      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
    getSeconds(d) {
      let _range =
        new Date(d).getTime() - new Date(this.course.date.now).getTime();

      if (_range > 0) {
        return _range;
      }
    },
    timerEnded() {
      this.beforeInit();
      this.$emit("on-jitsi-loaded");
      // if(this.task.i1==1)
      //     window.open(this.task.taskEn, '_blank');
      // else
      //     this.$emit('on-detail', this.task.id);
    },
    beforeInit() {
      // if(!hasOneOf(['learningteacher', 'learningadmin'], this.$store.state.user.access)){
      //     this.toolbarButtons=[
      //         'microphone', 'camera', 'closedcaptions', 'desktop', 'fullscreen',
      //         'fodeviceselection', 'hangup',
      //         'etherpad', 'sharedvideo', 'shareaudio', 'settings', 'raisehand',
      //         'videoquality', 'filmstrip',
      //         'tileview', 'select-background',
      //         ]
      // }
      this.notifications = [
        "connection.CONNFAIL", // shown when the connection fails,
        "dialog.cameraNotSendingData", // shown when there's no feed from user's camera
        "dialog.kickTitle", // shown when user has been kicked
        "dialog.liveStreaming", // livestreaming notifications (pending, on, off, limits)
        "dialog.lockTitle", // shown when setting conference password fails
        "dialog.maxUsersLimitReached", // shown when maximmum users limit has been reached
        "dialog.micNotSendingData", // shown when user's mic is not sending any audio
        "dialog.passwordNotSupportedTitle", // shown when setting conference password fails due to password format
        "dialog.recording", // recording notifications (pending, on, off, limits)
        "dialog.remoteControlTitle", // remote control notifications (allowed, denied, start, stop, error)
        "dialog.reservationError",
        "dialog.serviceUnavailable", // shown when server is not reachable
        "dialog.sessTerminated", // shown when there is a failed conference session
        "dialog.sessionRestarted", // show when a client reload is initiated because of bridge migration
        "dialog.tokenAuthFailed", // show when an invalid jwt is used
        "dialog.transcribing", // transcribing notifications (pending, off)
        "dialOut.statusMessage", // shown when dial out status is updated.
        "liveStreaming.busy", // shown when livestreaming service is busy
        "liveStreaming.failedToStart", // shown when livestreaming fails to start
        "liveStreaming.unavailableTitle", // shown when livestreaming service is not reachable
        "lobby.joinRejectedMessage", // shown when while in a lobby, user's request to join is rejected
        "lobby.notificationTitle", // shown when lobby is toggled and when join requests are allowed / denied
        "localRecording.localRecording", // shown when a local recording is started
        //'notify.disconnected', // shown when a participant has left
        //'notify.connectedOneMember', // show when a participant joined
        //'notify.connectedTwoMembers', // show when two participants joined simultaneously
        //'notify.connectedThreePlusMembers', // show when more than 2 participants joined simultaneously
        "notify.grantedTo", // shown when moderator rights were granted to a participant
        "notify.invitedOneMember", // shown when 1 participant has been invited
        "notify.invitedThreePlusMembers", // shown when 3+ participants have been invited
        "notify.invitedTwoMembers", // shown when 2 participants have been invited
        "notify.kickParticipant", // shown when a participant is kicked
        "notify.moderationStartedTitle", // shown when AV moderation is activated
        "notify.moderationStoppedTitle", // shown when AV moderation is deactivated
        "notify.moderationInEffectTitle", // shown when user attempts to unmute audio during AV moderation
        "notify.moderationInEffectVideoTitle", // shown when user attempts to enable video during AV moderation
        "notify.moderationInEffectCSTitle", // shown when user attempts to share content during AV moderation
        "notify.mutedRemotelyTitle", // shown when user is muted by a remote party
        "notify.mutedTitle", // shown when user has been muted upon joining,
        "notify.newDeviceAudioTitle", // prompts the user to use a newly detected audio device
        "notify.newDeviceCameraTitle", // prompts the user to use a newly detected camera
        "notify.passwordRemovedRemotely", // shown when a password has been removed remotely
        "notify.passwordSetRemotely", // shown when a password has been set remotely
        "notify.raisedHand", // shown when a partcipant used raise hand,
        "notify.startSilentTitle", // shown when user joined with no audio
        "notify.unmute", // shown to moderator when user raises hand during AV moderation
        "prejoin.errorDialOut",
        "prejoin.errorDialOutDisconnected",
        "prejoin.errorDialOutFailed",
        "prejoin.errorDialOutStatus",
        "prejoin.errorStatusCode",
        "prejoin.errorValidation",
        "recording.busy", // shown when recording service is busy
        "recording.failedToStart", // shown when recording fails to start
        "recording.unavailableTitle", // shown when recording service is not reachable
        "toolbar.noAudioSignalTitle", // shown when a broken mic is detected
        "toolbar.noisyAudioInputTitle", // shown when noise is detected for the current microphone
        "toolbar.talkWhileMutedPopup", // shown when user tries to speak while muted
        "transcribing.failedToStart" // shown when transcribing fails to start
      ];
      //if(hasOneOf(["learningteacher", "learningadmin"], this.$store.state.user.access)){
      this.toolbarButtons = [
        "camera",
        //'chat',
        "closedcaptions",
        "desktop",
        "download",
        //'embedmeeting',
        "etherpad",
        //'feedback',
        "filmstrip",
        "fullscreen",
        "hangup",
        //'help',
        //'invite',
        "livestreaming",
        "microphone",
        "mute-everyone",
        "mute-video-everyone",
        "participants-pane",
        "profile",
        "raisehand",
        'recording',
        "security",
        "select-background",
        "settings",
        "shareaudio",
        "sharedvideo",
        "shortcuts",
        "stats",
        "tileview",
        "toggle-camera",
        "videoquality",
        "__end"
      ];
      // }else{
      //   this.toolbarButtons = [
      //     //'camera',
      //     //'chat',
      //     'closedcaptions',
      //     //'desktop',
      //     'download',
      //     //'embedmeeting',
      //     //'etherpad',
      //     //'feedback',
      //     'filmstrip',
      //     'fullscreen',
      //     'hangup',
      //     //'help',
      //     //'invite',
      //     //'livestreaming',
      //     //'microphone',
      //     //'mute-everyone',
      //     //'mute-video-everyone',
      //     'participants-pane',
      //     //'profile',
      //     'raisehand',
      //     //'recording',
      //     //'security',
      //     //'select-background',
      //     //'settings',
      //     //'shareaudio',
      //     //'sharedvideo',
      //     ///'shortcuts',
      //     //'stats',
      //     'tileview',
      //     //'toggle-camera',
      //     'videoquality',
      //     '__end'
      //     ];
      // }

      this.rdy = true;
      this.$nextTick(() => {
        this.init();
      });
    },
    init() {
      const token = this.generate(
        this.privateKey,
        {
          id: this.$store.state.user.userId,
          name: this.$store.state.user.userInfo.fullName,
          email: this.$store.state.user.mail,
          avatar: this.$store.state.user.userInfo.avator,
          //appId: "vpaas-magic-cookie-2f2b4308bc4043b1a3362bdd4cc8b75c", // Your AppID ( previously tenant )
          appId: "vpaas-magic-cookie-b2daff7888774cff80d4b16d3afb4e36", // Your AppID ( previously tenant )

          kid: `vpaas-magic-cookie-b2daff7888774cff80d4b16d3afb4e36/dfeb38`,
          moderator: hasOneOf(
            ["learningteacher", "learningadmin"],
            this.$store.state.user.access
          )
        },
        {
          livestreaming: true,
          recording: true,
          transcription: true,
          outboundCall: true
        }
      );

      //const api = new JitsiMeetExternalAPI(meetingUrl, {
        // const api = new window.JitsiMeetExternalAPI(meetingUrl, {
      const api = new JitsiMeetExternalAPI(meetingUrl, {
        //const api = new JitsiMeetExternalAPI("8x8.vc", {
        roomName:
          "vpaas-magic-cookie-b2daff7888774cff80d4b16d3afb4e36/" +
          this.task.task,
        parentNode: document.querySelector("#jaas-container"),
        jwt: token,
        //width:700,
        //height: 800,
        configOverwrite: {
          // {
          //     inviteDomain: 'example-company.org',
          //     backgroundColor: '#fff',
          //     backgroundImageUrl: 'https://example.com/background-img.png',
          //     logoClickUrl: 'https://example-company.org',
          //     logoImageUrl: 'https://example.com/logo-img.png'
          // },
          //logoImageUrl: 'https://app.gosmart.mn/img/logo-min.2558da13.png',
          startWithVideoMuted: true,
          startWithAudioMuted: true,
          //clientNode: 'http://jitsi.org/jitsimeet',
          prejoinPageEnabled: false,
          enableWelcomePage: false,
          //defaultLanguage: 'af',
          toolbarButtons: this.toolbarButtons,
          notifications: this.notifications,
          // p2p: {
          //     enabled: false,
          // },
          apiLogLevels: [],
          // deploymentInfo: {
          //     shard: "shard1",
          //     region: "asia",
          //     userRegion: "asia"
          // },
          // localRecording: {
          //     enabled: true,
          //     format: 'flac'
          // },
          // dropbox: {
          //     appKey: 'zyaqxoaga7qeo6n',
          //     redirectURI: 'https://meet.gosmart.mn/static/oauth.html'
          // },
          toolbarConfig: {
            initialTimeout: 60000,
            timeout: 60000,
            alwaysVisible: true
          }
        }
        // interfaceConfigOverwrite:{
        //     DEFAULT_BACKGROUND: '#474747',
        //     DEFAULT_LOCAL_DISPLAY_NAME: 'me',
        //     DEFAULT_LOGO_URL: 'https://app.gosmart.mn/img/logo-min.2558da13.png',
        //     DEFAULT_REMOTE_DISPLAY_NAME: 'Fellow Jitster',
        //     DEFAULT_WELCOME_PAGE_LOGO_URL: 'https://app.gosmart.mn/img/logo-min.2558da13.png',
        // },
      });
    },
    generate(
      privateKey,
      { id, name, email, avatar, appId, kid, moderator },
      { livestreaming, recording, transcription, outboundCall }
    ) {
      //const now = new Date()
      var startdate = new Date(this.task.dueStartDate);
      var enddate = new Date(this.task.dueDate);
      const jwt = jsonwebtoken.sign(
        {
          //aud: "jitsi",

          context: {
            user: {
              id: id,
              name: name,
              avatar: avatar,
              email: email,
              moderator: moderator
            },
            features: {
              livestreaming: true,
              "outbound-call": true,
              transcription: true,
              recording: true
            },
            room: {
              regex: false
            },
            moderator: moderator
          },
          aud: "vpaas-magic-cookie-b2daff7888774cff80d4b16d3afb4e36",

          iss: "vpaas-magic-cookie-b2daff7888774cff80d4b16d3afb4e36",

          sub: meetingUrl,

          room: "*",
          moderator: moderator,

          // context: {
          //   user: {
          //     id,
          //     name,
          //     avatar,
          //     email: email,
          //     moderator: moderator,
          //   },
          //   features: {
          //     // livestreaming: 'true',
          //     // recording: 'true',
          //     // transcription: 'true',
          //     // "outbound-call": 'true'
          //     livestreaming: livestreaming,
          //     recording: recording,
          //     transcription: transcription,
          //     "outbound-call": outboundCall,
          //   },
          // },
          //iss: "chat",
          //room: "*",
          //sub: appId,
          //exp: Math.round(now.setHours(now.getHours() + 3) / 1000),
          exp: Math.round(enddate.setHours(enddate.getHours() + 24) / 1000),
          //nbf: (Math.round((new Date).getTime() / 1000) - 10)
          nbf: Math.round(startdate.setHours(startdate.getHours() - 24) / 1000)
        },
        //privateKey,
        //{ algorithm: "RS256", header: { kid } }
        //{ algorithm: "HS256", header: { kid } },
        "dfeb38"
      );

      //console.log("jwt=> ", jwt);
      return jwt;
    }
  }
};
</script>

<style></style>
